import type { Http } from '../http';
import { endpoints } from '../endpoints';
import type { RawRevenueResponse } from '../types/revenue';
import type { RequestOptions } from '../types/common';

export function createRevenueApi(http: Http) {
  return {
    async get(
      period: 'hourly' | 'daily' | 'monthly',
      start: string,
      end: string,
      plantId?: string,
      options?: RequestOptions,
    ): Promise<RawRevenueResponse> {
      const res = await http.get<RawRevenueResponse>(
        endpoints.revenue.byPeriod(period, start, end),
        {
          params: plantId !== undefined ? { plantId } : undefined,
          signal: options?.signal,
        },
      );
      return res.data;
    },
  };
}
